import React, { useCallback, useRef } from "react";
import { Stack } from "@mui/material";
import HeroBackdrop from "./HeroBackdrop";

interface PageLayoutProps {
    hero?: React.ReactNode;
    children: React.ReactNode;
    onScrollY?: (y: number) => void;
}

const PageLayout: React.FC<PageLayoutProps> = ({
    hero,
    children,
    onScrollY,
}) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const handleScroll = useCallback(() => {
        if (!scrollRef.current || !onScrollY) return;
        onScrollY(scrollRef.current.scrollTop);
    }, [onScrollY]);

    return (
        <Stack
            ref={scrollRef}
            onScroll={handleScroll}
            direction="column"
            width="100%"
            flex={1}
            sx={{
                overflowY: "auto",
                overflowX: "hidden",
                // White background so short content doesn't reveal hero color below the sheet
                bgcolor: hero ? "white" : undefined,
            }}
        >
            {hero && <HeroBackdrop>{hero}</HeroBackdrop>}
            <Stack
                sx={{
                    bgcolor: "white",
                    borderTopLeftRadius: hero ? "24px" : 0,
                    borderTopRightRadius: hero ? "24px" : 0,
                    marginTop: hero ? "-24px" : 0,
                    position: "relative",
                    zIndex: 1,
                    px: 2,
                    pt: hero ? 3 : "72px",
                    // Footer is 87px fixed at bottom; give enough clearance
                    pb: "100px",
                    boxSizing: "border-box",
                    "@keyframes fadeSlideIn": {
                        from: { opacity: 0, transform: "translateY(12px)" },
                        to: { opacity: 1, transform: "translateY(0)" },
                    },
                    animation: "fadeSlideIn 0.3s ease-out",
                }}
                spacing={3}
            >
                {children}
            </Stack>
        </Stack>
    );
};

export default PageLayout;
